var _pattern, _rect, _rect2, _path, _g, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 60",
    width: 400,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "borderGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F5F0E6",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    style: {
      stopColor: "#E5DECF",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#5F7A61",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    style: {
      stopColor: "#E5DECF",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F5F0E6",
      stopOpacity: 0.8
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "stonePattern",
    patternUnits: "userSpaceOnUse",
    width: 20,
    height: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    fill: "url(#borderGradient)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 1,
    fill: "#E5DECF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 3,
    r: 1,
    fill: "#F5F0E6",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 1,
    fill: "#5F7A61",
    opacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 60,
    fill: "url(#borderGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 60,
    fill: "url(#stonePattern)",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 30 Q 100 10 200 30 Q 300 50 400 30",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 25,
    width: 2,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 27,
    width: 10,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 25,
    width: 2,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 27,
    width: 10,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 25,
    width: 2,
    height: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 27,
    width: 10,
    height: 2,
    fill: "#FFFFFF"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55,
    width: 400,
    height: 5,
    fill: "url(#borderGradient)",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBorder);
export default __webpack_public_path__ + "static/media/footer-border.0a42310a7ce87717e1df92f9cbf102bb.svg";
export { ForwardRef as ReactComponent };